export default function generateLocaleAwarePolicyIndex(params) {
    const {
        locale,
        policy,
    } = params;

    return `${locale}-${policy}`;
}
